module.exports = __webpack_public_path__ + "assets/img/banner2.c327f1b2.jpg";